import { HttpClient } from "@angular/common/http";
import { Component, Input, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { CacheService } from "@delon/cache";
import { TranslateService } from "@root/shared/service/translate.service";
import { NzModalRef } from "ng-zorro-antd/modal";

@Component({
  selector: "v4-houses-modal-select",
  templateUrl: "./houses-modal-select.component.html",
  styleUrls: ["./houses-modal-select.component.scss"],
})
export class V4HousesModalSelectComponent implements OnInit {
  readonly listApi = "/api/house/search";
  @Input() mode: "multi" | "single" = "multi";
  @Input() selectedValues: number[];
  @Input() params; // 额外的过滤参数
  listOfData: Option[] = [];
  listOfExtraData: Option[] = [];
  listOfGroupOption: Option[];
  listOfHouseTypeOption: Option[];
  listOfTagOption: Option[];
  form: UntypedFormGroup = this.fb.group({
    title: null,
    group_id: null,
    house_type_id: null,
    house_tag_id: null,
  });

  constructor(
    private http: HttpClient,
    private fb: UntypedFormBuilder,
    private modalRef: NzModalRef,
    private cache: CacheService,
    private t: TranslateService,
  ) {}

  ngOnInit() {
    this.fetchGroupList();
    this.fetchHouseTypeList();
    this.fetchTagList();

    this.fetchDataList();

    this.subscribeFormChange();
  }

  private subscribeFormChange() {
    this.form.valueChanges.subscribe(() => {
      this.fetchDataList();
    });
  }

  fetchDataList() {
    const value = this.form.value;
    const params = {
      ...value,
      page: 1,
      page_size: 10000,
      type: "include_delete",
    };
    if (value.house_tag_id) {
      Object.assign(params, {
        house_tag_type: "include",
        house_tag_id: JSON.stringify([value.house_tag_id]),
      });
    }
    if (this.params) {
      Object.assign(params, this.params);
    }
    this.http.get(this.listApi, { params }).subscribe((rst: any) => {
      this.listOfData = rst?.data?.list
        ?.filter((item) => !item.delete_time)
        ?.map((item) => ({
          label: item.house_title,
          value: item.id,
        }));
      this.listOfExtraData = rst?.data?.list
        ?.filter((item) => item.delete_time)
        ?.map((item) => ({
          label: item.house_title,
          value: item.id,
        }));
      console.log("listOfData: ", this.listOfData);
    });
  }

  private fetchGroupList() {
    return this.cache
      .get("/api/house_group/group_list", { mode: "promise", type: "m", expire: 1 * 60 })
      .subscribe((rst: any) => {
        const list = rst?.data?.list?.map((item) => ({
          label: item.name,
          value: item.group_id,
        }));
        this.listOfGroupOption = [
          {
            label: this.t.t("word.any"),
            value: null,
          },
        ].concat(list);
      });
  }

  private fetchHouseTypeList() {
    return this.cache
      .get("/api/house_type/all", { mode: "promise", type: "m", expire: 1 * 60 })
      .subscribe((rst: any) => {
        const list = rst?.data?.list?.map((item) => ({
          label: item.title,
          value: item.id,
        }));
        this.listOfHouseTypeOption = [
          {
            label: this.t.t("word.any"),
            value: null,
          },
        ].concat(list);
      });
  }

  private fetchTagList() {
    return this.cache
      .get("/api/house_status_setting/get", { mode: "promise", type: "m", expire: 1 * 60 })
      .subscribe((rst: any) => {
        const list = rst?.data?.house_tag?.map((item) => ({
          label: item.name,
          value: item.id,
        }));
        this.listOfTagOption = [
          {
            label: this.t.t("word.any"),
            value: null,
          },
        ].concat(list);
      });
  }

  onConfirm(options: Option[]) {
    // this.modalRef.destroy(options);
    this.modalRef.destroy({
      status: "ok",
      data: options,
      rst: options,
    });
    console.log("onConfirm: ", options);
  }

  onCancel() {
    // this.modalRef.destroy();
    this.modalRef.destroy({ status: "cancel" });
  }

  onReset() {
    console.log("on reset");
    this.selectedValues = [];
  }
}
